'use client';

import { faAngleLeft, faHouseHeart } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';

import { MainHeaderSkeleton } from '@/components/organisms/skeletons/MainHeaderSkeleton';
import { useTeamLeagueDetailsQuery } from '@/hooks/team-leagues/useDetailsQuery';

type Variant = 'navigation' | 'main';

interface MainContentHeaderProps {
	playerId?: string;
	variant?: Variant;
	previousPageTitle?: string;
	backLinkUrl?: string;
	className?: string;
	teamLeagueId: string;
}

export const MainHeader = ({ variant, backLinkUrl, previousPageTitle, className, teamLeagueId }: MainContentHeaderProps) => {
	//TO DO
	// const playerInfo = await getPlayerInfoController(organizationId, playerId);

	// if (!playerInfo.data) {
	// 	return <TeamLeaguesErrorPage title="Failed to fetch player info" />;
	// }
	const { data: leagueInfoResponse, isLoading } = useTeamLeagueDetailsQuery(teamLeagueId);

	if (isLoading || !leagueInfoResponse) {
		return <MainHeaderSkeleton variant="navigation" />;
	}

	if (leagueInfoResponse.statusCode !== 200) {
		return null;
	}

	const leagueInfo = leagueInfoResponse.data;

	return (
		<div className={`m-auto flex h-9 w-full items-center justify-between bg-white ${className}`}>
			{variant === 'navigation' ? (
				<div className="mx-0 mb-4 flex h-6 cursor-pointer items-center gap-2 px-0">
					<Link href={backLinkUrl ?? '#'} prefetch={false} className="flex items-center gap-2 text-gray-900 hover:text-gray-700">
						<FontAwesomeIcon icon={faAngleLeft} className="size-5" />
						<span className="text-base font-medium leading-6">{previousPageTitle}</span>
					</Link>
				</div>
			) : (
				<>
					<Link href={backLinkUrl ?? '#'} className="flex items-center gap-2 text-gray-900 hover:text-gray-700">
						<div className="mx-0 flex h-6 items-center gap-2 px-0">
							<FontAwesomeIcon icon={faHouseHeart} className="size-5 text-gray-900" />
							<span className="text-base font-medium leading-6 text-black">{leagueInfo?.title}</span>
						</div>
					</Link>

					{/* <div className="hidden items-center gap-6 sm:flex">
						<div className="flex cursor-pointer items-center gap-2">
							<FontAwesomeIcon icon={faGripHorizontal} className="size-5 px-[3px] text-xl font-normal leading-8 text-darkorange-400" />
							<span className="text-base font-medium leading-6 text-darkorange-400">Dashboard</span>
						</div>
					</div> */}
				</>
			)}
		</div>
	);
};
